export const ROLE_COLLECTION_ID = 'roles';

